import request from '@/utils/request'

export function overdraft(data) {
  return request({
    url: '/ustn/overdraft',
    method: 'get',
    params: data
  })
}

export function mytotal(data) {
  return request({
    url: '/auction/mytotal',
    method: 'get',
    params: data
  })
}
